<div class="page">
  <div class="container-sm m-auto">
    <div class="row">
      <div class="col-12 page-title">
        <h1>{{title}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6" *ngFor="let experience of experiences">
        <app-experience-item [experience]="experience"></app-experience-item>
      </div>
    </div>
  </div>
</div>
